import React from "react";
import { Image, Modal } from "react-bootstrap";
import CloseBtn from "../CloseBtn";

const ImageModal = ({ show, onHide, image, alt }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      className="image-modal"
    >
      <div className="overflow-auto h-100">
        <Image src={image} alt={alt} fluid />
        <CloseBtn onClick={onHide} color="white" />
      </div>

      {/* <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Delete
          </Button>
        </Modal.Footer> */}
    </Modal>
  );
};

export default ImageModal;
